import { render } from "./instructor-five.vue?vue&type=template&id=23ff4186"
import script from "./instructor-five.vue?vue&type=script&lang=js"
export * from "./instructor-five.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__